import React, { Component } from "react";
import styled from "styled-components";
import Icon from "module-common/Icon";
import { CommonStore } from "Store";

export default class EmptyPanel extends Component {
  render() {
    return (
      <Wrapper>
        <StyledIcon name="empty" width={150} height={150} />
        <Title>{`Hello, Welcome to ${
          CommonStore.me.company.displayName
        } Care`}</Title>
        <Message>Please select one of the case on the left</Message>
      </Wrapper>
    );
  }
}

const Wrapper = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;
const StyledIcon = styled(Icon)`
  opacity: 0.5;
  margin-bottom: 16px;
  margin-left: 30px;
`;
const Title = styled.div`
  font-size: 1.285rem;
  color: #96a9b7;
  line-height: 2;
`;
const Message = styled.div`
  color: #96a9b7;
  font-size: 0.857rem;
`;



// WEBPACK FOOTER //
// ./src/module-case-management/content-panel/EmptyPanel.js